// Hack to make distance between icon and text the same as in the stop sales button
.button > span:first-child {
  margin-right: 0.05em;
}
